import { render, staticRenderFns } from "./package_board.vue?vue&type=template&id=12bee150&scoped=true&"
import script from "./package_board.vue?vue&type=script&lang=js&"
export * from "./package_board.vue?vue&type=script&lang=js&"
import style0 from "./package_board.vue?vue&type=style&index=0&id=12bee150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bee150",
  null
  
)

export default component.exports